const doc = [({"en":({"js":({"merfoto":({"routes":({"welcome":({"welcome":"Welcome"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;